import React, { forwardRef, useEffect, useState } from "react";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import moment from "moment";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { useGetCollectPaymentContext } from "../../context";
import {
  getBalanceAmount, getPaymentModeName, statusStyle,
  //  validatePaymentMode 
} from "../components/constant";
import { voucherValidtion } from "../validations/paymentModeValidation";
import { formattedPrice } from "../../utils";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { regex } from "views/pages/manage/common/constant";
import { handleVoucherRetrieval } from "../../apis";

const ListComponent = forwardRef(
  ({ rows, loader, setRows, setOpen, setVoucherLoader, setErrorMgs, accessiblePaymentModeList, module,getVouchers }, ref) => {
    const {
      balanceAmount,
      setCollectVoucherList,
      studentBasicDetails,
      currentPaymentMode,
      paymentModeForm,
      selectedChargesAmount,
      bankMasterId,
      setBalanceAmount,
      setBalanceMode,
      setCollectPayment,
      collectPayment,
      collectVoucherList,
      totalUnpaidAmount,
      setCurrentPageState,
      setCurrentStep,
      isOpen,
      validatePaymentMode,
    } = useGetCollectPaymentContext(module);
    const [previousAmount, setPreviousAmount] = useState(0);
    const [voucherAmount, setVoucherAmount] = useState(); //represents total  applied voucher amount (saved or unsaved)
    const [rowModesModel, setRowModesModel] = useState({});//unnecessary state
    const [totalAmount, setTotalAmount] = useState(0); //unnecessary state
    const [dummyBalance, setDummyBalance] = useState() //represents balanceAmount after applying voucher(saved or unsaved)
    const [preTotalAmount, setPreTotalAmount] = useState(0); // represents total  applied voucher amount (saved) 
    const [rowData, setRowData] = useState([]);
    const [isSelectChargesButton, setSelectChargesButton] = useState(false)
    const [dummyPayMode, setDummyPayMode] = useState()
    const [retryTransactionId, setRetryTransactionId] = useState({});
    useEffect(() => {
      const totalVoucherCost = (rows
        .filter((item) => item?.applied)
        .reduce((sum, item) => sum + (item?.appliedVoucherAmount || 0), 0)) ?? 0; // Sum voucher amounts
      setDummyBalance(balanceAmount)
      setTotalAmount(totalVoucherCost);
      setPreTotalAmount(totalVoucherCost);
      setRowData(rows)
      setErrorMgs('')
    }, [rows]);

    const statusMapping = {
      PAID: 'Success',
      FAILED: 'Failed',
      PENDING: 'Status Pending',
      TXN_SUCCESS: 'Success',
      'SETTLEMENT IN PROCESS': 'Success',
      'MONEY SETTLED': 'Success',
      'SUCCESS': 'Success',
      'ALREADY RECEIPTED USING A DIFFERENT VOUCHER': 'Success',
      INPROGRESS: 'In Progress'
    }

    const handleApply = async (param, isAutoApplied = false) => {

      if (!accessiblePaymentModeList.includes(param?.row?.type) && !((param?.row?.type == 'LINK' || param?.row?.type == 'Link') && (accessiblePaymentModeList.includes('Link') || accessiblePaymentModeList.includes('LINK')))) {
        failureToast("You don't have sufficient payment mode rights to apply this voucher")
        return
      }

      const { receiptingEnabledBusinessArea, bu } = studentBasicDetails;
      const isReceiptingEnabledOnStudentBu = receiptingEnabledBusinessArea?.includes(bu);

      const { voucherType, voucherBalanceAmount } = param?.row;
      // const isErpVoucher =  voucherType === 'ERP';
      const appliedVoucherAmount = (isReceiptingEnabledOnStudentBu && dummyBalance > 0) ? Math.min(dummyBalance, voucherBalanceAmount) : voucherBalanceAmount;

      const error = voucherValidtion(
        // Math.abs(totalAmount-voucherAmount) + param?.row?.voucherBalanceAmount,
        appliedVoucherAmount,
        dummyBalance
      );
      if (error) {
        if ((['CC', 'DB'].includes(param?.row?.type))) {
          // if(totalUnpaidAmount>(param?.row?.voucherBalanceAmount+voucherAmount))
          if (totalUnpaidAmount > (appliedVoucherAmount + voucherAmount)) {
            setSelectChargesButton(true)
            setErrorMgs(error);
            return;
          }
        }
        else {
          setErrorMgs(error);
          return;
        }
      }
      else {
        setErrorMgs('')
      }
      const isValid = isAutoApplied || await validatePaymentMode(
        studentBasicDetails,
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        { ...param?.row, appliedVoucherAmount },
        setBalanceAmount,
        setBalanceMode,
        setVoucherLoader,
        setCollectPayment,
        balanceAmount,
        collectPayment
      );
      if (isValid) {
        setDummyPayMode(param?.row?.type)
        setSelectChargesButton(false)
        const row = { ...param?.row, applied: true, appliedVoucherAmount };
        const newArray = [...rowData];
        newArray[param?.id] = row;
        // setVoucherAmount(voucherAmount + param?.row?.voucherBalanceAmount);
        setVoucherAmount(voucherAmount + appliedVoucherAmount);
        setRowData(newArray);
        isAutoApplied && onConfirmHandler(newArray, appliedVoucherAmount)
        // setDummyBalance((prev)=>prev-param?.row?.voucherBalanceAmount)
        setDummyBalance((prev) => prev - appliedVoucherAmount)
      } else {
        return;
      }
    };
    const handleRemove = (param) => {
      const row = { ...param?.row, applied: false, appliedVoucherAmount: 0 };
      const newArray = [...rowData];
      newArray[param?.id] = row;
      //setPreviousAmount(totalAmount);
      // setVoucherAmount(voucherAmount - param?.row?.voucherBalanceAmount);
      setVoucherAmount(voucherAmount - param?.row?.appliedVoucherAmount);
      setRowData(newArray);
      // (rows[param?.id]?.applied)&&setTotalAmount(totalAmount-param?.row?.voucherBalanceAmount)
      // const balance=dummyBalance+param?.row?.voucherBalanceAmount
      (rows[param?.id]?.applied) && setTotalAmount(totalAmount - param?.row?.appliedVoucherAmount)
      const balance = dummyBalance + param?.row?.appliedVoucherAmount
      setDummyBalance(balance)
      setDummyPayMode('')
    };

    const onConfirmHandler = (autoApplyVoucher = false, autoApplyVoucherAmount) => {
      autoApplyVoucher ? setRows(autoApplyVoucher) : setRows(rowData);
      (preTotalAmount !== voucherAmount || autoApplyVoucher) && // buggy condition
        getBalanceAmount(
          autoApplyVoucherAmount || (voucherAmount - preTotalAmount),
          balanceAmount,
          setBalanceAmount,
          setBalanceMode,
          true,
          // rowData
        );
      // setPreviousAmount(autoApplyVoucherAmount||voucherAmount);
      let collectVochersList = [];
      const data = autoApplyVoucher || rowData
      data.forEach((item) => {
        if (item?.applied) {
          collectVochersList.push({
            vId: item?.vId,
            paymentMode: item?.type,
            paymentModeId: bankMasterId[item?.type],
            // paidAmount: item?.voucherBalanceAmount,
            paidAmount: item?.appliedVoucherAmount,
            voucherUTRKey: item?.voucherId,
            referenceNumber: item?.description,
            paymentModeDate: item?.transactionDateAndTime
              ? moment(item?.transactionDateAndTime).format("YYYY-MM-DD")
              : null,
            voucherType: item?.voucherType,
            cardType: item?.cardType,
            bankName: item?.bakName,
            firstName: item?.firstName,
            lastName: item?.lastName,
            onlineSale: item?.onlineSale,
            source: item?.source
          });
        }
      });
      setCollectVoucherList(collectVochersList);
      !autoApplyVoucher && setOpen(false);
    };

    useEffect(() => {
      const totalVoucherCost = rowData
        .filter((item) => item?.applied === true)
        .reduce((sum, item) => sum + (item?.appliedVoucherAmount || 0), 0); // Sum voucher amounts
      setVoucherAmount(totalVoucherCost);
      const autoApplyVoucher = rowData.find(item => (item?.isAutoApplied === true && item?.applied != true))
      rowData.length > 0 && autoApplyVoucher && dummyBalance && accessiblePaymentModeList.length > 0 && handleApply({ row: autoApplyVoucher, id: autoApplyVoucher.id }, true)
    }, [rowData, accessiblePaymentModeList]); // Add rowData to the dependency array

    const item = [...collectPayment, ...collectVoucherList]
    const paymentModeCollected = item.length > 0 ? item[0].paymentMode : ''

    const chjeckDummyVoucherType = (type) => {
      for (let i in rowData) {
        if (rowData[i]?.type != type)
          return true
      }
    }
const handleRetry = async(param) => {
      if (!retryTransactionId?.[param?.id]) {
        failureToast("Please enter Transaction ID to retry")
        return
      }
      else {
        const isSuccess= await handleVoucherRetrieval({
          vendorId: param?.row?.clientTransactionId,
          retryTransactionId: retryTransactionId?.[param?.id],
          buId: studentBasicDetails?.buId,
          vendorType: 'AXIS_BANK_BOX'
        })
        if (isSuccess) {  
          getVouchers();
          setRetryTransactionId((prev)=>({...prev,[param?.id]:''}));
        }
      }

}
    const columns = [
      new AGridColDef("type", "Type", false)
        .setMinWidth(110)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={getPaymentModeName(params?.value)}>
              <div className={`ellipsis-text-container`}>{getPaymentModeName(params?.value) ?? params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("description", "Desc", false)
        .setMinWidth(140)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("voucherId", "Voucher ID", false)
        .setMinWidth(140)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("transactionDateAndTime", "Tran. Date", false)
        .setMinWidth(110)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip
              title={`${moment(params?.value).format(
                "DD-MMM-YYYY"
              )}`}
            >
              <div className="ellipsis-text-container">{`${moment(
                params?.value
              ).format("DD-MMM-YYYY")}`}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("term", "Term", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.8)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("courseId", "Course ID", false)
        .setMinWidth(100)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("voucherBalanceAmount", "Balance Amount", false)
        .setMinWidth(100)
        .editable(true)
        .setFlex(0.5)
        .columnAlign('right')
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={formattedPrice(params?.value)}>
              <div className={`ellipsis-text-container`}>{formattedPrice(params?.value)}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("source", "Source", false)
        .setMinWidth(90)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`} >{params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("status", "Status", false)
        .setMinWidth(110)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <Tooltip title={statusMapping[(params?.value).toUpperCase()]}>
              <div className={`ellipsis-text-container`} style={statusStyle[statusMapping[(params?.value).toUpperCase()]]}>{statusMapping[(params?.value).toUpperCase()] ?? params?.value}</div>
            </Tooltip>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("action", "Action", false)
        .setMinWidth(200)
        .editable(true)
        .setFlex(2)
        .renderCellComponent((params) => {
          console.log(params?.row)
          return (
            (params?.row?.status === 'INPROGRESS' || params?.row?.status === 'FAILED' || params?.row?.status === 'PENDING')
            && params?.row?.type === 'AXSB'
          ) ? (
            // ---- RETRY BLOCK ----
            <div className="d-flex" style={{ gap: '6px' }}>
              <AInput
                placeholder='Enter'
                value={retryTransactionId?.[params?.id]}
                handler={(value) => {
                  if(value.length<=22)
                  setRetryTransactionId((prev)=>({...prev,[params?.id]:value}))
                }}
                onPaste={true}
                regex={regex.numeric}
                disabled={false}
              />
              <AButton
                onClick={() => handleRetry(params)}
                size="xs"
                variant="outline_danger"
                className="btn-left-0"
                disabled={!retryTransactionId}
              >
                Retry
              </AButton>
            </div>
          ) : (params?.row?.status != 'FAILED') && (!params?.row?.applied ? (
            <AButton
              onClick={() => {
                handleApply(params);
              }}
              size="xs"
              variant="primary_filled"
              className="btn-left-0"
              disabled={(paymentModeCollected && paymentModeCollected != params?.row?.type) || statusMapping[params?.row?.status] != 'Success' || dummyPayMode && (dummyPayMode != params?.row?.type)}
            >
              Apply
            </AButton>
          ) : (
            <AButton
              onClick={() => {
                handleRemove(params);
              }}
              size="xs"
              variant="outline_danger"
              className="btn-left-0"
              disabled={params?.row?.isAutoApplied}
            >
              Remove
            </AButton>
          )
          )
        }
        ),
    ];

    return (
      <>
        <div
          className=""
          style={{ border: "1px solid #EEE", borderRadius: "8px" }}
        >
          <ADataGrid
            removeWrapperContainer
            rowModesModel={rowModesModel}
            rows={rowData || []}
            columns={columns}
            rowId={(row) => row?.id}
            rowHeight={50}
            rowCount={rowData.length}
            loading={false}
            components={{
              ...gridComponents,
              NoRowsOverlay: () => (
                <NoRowOverlay message={loader ? "Loading..." : null} />
              ),
            }}
            sx={{
              ...gridStyles,
            }}
            maxHeight={'300px'}
            hidePagination={true}
          />
        </div>
        {voucherAmount ? (
          <span>
            Total Amount Selected{" "}
            <span className="large-bold">{`${formattedPrice(voucherAmount)}`}</span>
          </span>
        ) : (
          ""
        )}
        <AButton
          onClick={isSelectChargesButton ? () => {
            setCurrentPageState('SELECT_CHARGES')
            setCurrentStep((prev) => prev - 1);
            setCollectVoucherList([])
          } : () => {
            onConfirmHandler();
          }}
          size="xs"
          variant="primary_filled"
          className="btn-left-0"
          updatedStyle={{ padding: "17px 16px", width: "207px" }}
        >
          {isSelectChargesButton ? 'Go to select charges' : 'Done'}
        </AButton>
      </>
    );
  }
);
export default ListComponent;
